import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "configuration-keys"
    }}>{`Configuration keys`}</h1>
    <h2 {...{
      "id": "lifecyclesessiontimeout"
    }}>{`lifecycle.sessionTimeout`}</h2>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`This configuration setting is only used in the Analytics use case, when using the `}<a parentName="p" {...{
        "href": "./event-reference.md#lifecycle-data-content-response"
      }}>{`Lifecycle data content response`}</a>{` event to determine session length. `}<br /><br />{` In the Platform use case, events are dispatched based on `}<a parentName="p" {...{
        "href": "./event-reference.md#lifecycle-application-foreground"
      }}>{`Lifecycle Application Foreground`}</a>{` and `}<a parentName="p" {...{
        "href": "./event-reference.md#lifecycle-application-background"
      }}>{`Lifecycle Application Background`}</a>{` and not on a set session timeout.`}</p>
    <p>{`Number of seconds that must elapse between the app entering the background and subsequently re-entering the foreground in order for the SDK to create a new session.`}</p>
    <p>{`The default value is 300 seconds (5 minutes).`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`The time that your app spends in the background is `}<strong parentName="p">{`not`}</strong>{` included in the session length.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      